// Auto-generated Kotlin_ components map

import Kotlin_Arrays from "./components/Kotlin_Arrays.jsx";
import Kotlin_Booleans from "./components/Kotlin_Booleans.jsx";
import Kotlin_Break_Continue from "./components/Kotlin_Break_Continue.jsx";
import Kotlin_Certificate from "./components/Kotlin_Certificate.jsx";
import Kotlin_Classes_Objects from "./components/Kotlin_Classes_Objects.jsx";
import Kotlin_ClassFunctions from "./components/Kotlin_Class_Functions.jsx";
import Kotlin_Comments from "./components/Kotlin_Comments.jsx";
import Kotlin_Compiler from "./components/Kotlin_Compiler.jsx";
import Kotlin_Constructors from "./components/Kotlin_Constructors.jsx";
import Kotlin_Data_Types from "./components/Kotlin_Data_Types.jsx";
import Kotlin_Examples from "./components/Kotlin_Examples.jsx";
import Kotlin_Exercises from "./components/Kotlin_Exercises.jsx";
import Kotlin_For_Loop from "./components/Kotlin_For_Loop.jsx";
import Kotlin_Functions from "./components/Kotlin_Functions.jsx";
import Kotlin_Get_Started from "./components/Kotlin_Get_Started.jsx";
import Kotlin_Home from "./components/Kotlin_Home.jsx";
import Kotlin_If_Else from "./components/Kotlin_If_Else.jsx";
import Kotlin_Inheritance from "./components/Kotlin_Inheritance.jsx";
import Kotlin_Intro from "./components/Kotlin_Intro.jsx";
import Kotlin_OOP from "./components/Kotlin_OOP.jsx";
import Kotlin_Operators from "./components/Kotlin_Operators.jsx";
import Kotlin_Output from "./components/Kotlin_Output.jsx";
import Kotlin_Quiz from "./components/Kotlin_Quiz.jsx";
import Kotlin_Ranges from "./components/Kotlin_Ranges.jsx";
import Kotlin_Strings from "./components/Kotlin_Strings.jsx";
import Kotlin_Study_Plan from "./components/Kotlin_Study_Plan.jsx";
import Kotlin_Syllabus from "./components/Kotlin_Syllabus.jsx";
import Kotlin_Syntax from "./components/Kotlin_Syntax.jsx";
import Kotlin_Variables from "./components/Kotlin_Variables.jsx";
import Kotlin_When from "./components/Kotlin_When.jsx";
import Kotlin_While_Loop from "./components/Kotlin_While_Loop.jsx";

const Kotlin_ComponentsMap = {
  "<Kotlin_Arrays />": Kotlin_Arrays,
  "<Kotlin_Booleans />": Kotlin_Booleans,
  "<Kotlin_Break_Continue />": Kotlin_Break_Continue,
  "<Kotlin_Certificate />": Kotlin_Certificate,
  "<Kotlin_Classes_Objects />": Kotlin_Classes_Objects,
  "<Kotlin_ClassFunctions />": Kotlin_ClassFunctions,
  "<Kotlin_Comments />": Kotlin_Comments,
  "<Kotlin_Compiler />": Kotlin_Compiler,
  "<Kotlin_Constructors />": Kotlin_Constructors,
  "<Kotlin_Data_Types />": Kotlin_Data_Types,
  "<Kotlin_Examples />": Kotlin_Examples,
  "<Kotlin_Exercises />": Kotlin_Exercises,
  "<Kotlin_For_Loop />": Kotlin_For_Loop,
  "<Kotlin_Functions />": Kotlin_Functions,
  "<Kotlin_Get_Started />": Kotlin_Get_Started,
  "<Kotlin_Home />": Kotlin_Home,
  "<Kotlin_If_Else />": Kotlin_If_Else,
  "<Kotlin_Inheritance />": Kotlin_Inheritance,
  "<Kotlin_Intro />": Kotlin_Intro,
  "<Kotlin_OOP />": Kotlin_OOP,
  "<Kotlin_Operators />": Kotlin_Operators,
  "<Kotlin_Output />": Kotlin_Output,
  "<Kotlin_Quiz />": Kotlin_Quiz,
  "<Kotlin_Ranges />": Kotlin_Ranges,
  "<Kotlin_Strings />": Kotlin_Strings,
  "<Kotlin_Study_Plan />": Kotlin_Study_Plan,
  "<Kotlin_Syllabus />": Kotlin_Syllabus,
  "<Kotlin_Syntax />": Kotlin_Syntax,
  "<Kotlin_Variables />": Kotlin_Variables,
  "<Kotlin_When />": Kotlin_When,
  "<Kotlin_While_Loop />": Kotlin_While_Loop,
};

export default Kotlin_ComponentsMap;
